import * as React from 'react';
import { ToolsTitleWrapper, ToolsWrapper } from '../ProfessionalExperienceSectionStyles';
import { language } from '../ProfessionalExperienceSectionLanguage';

export type Props = {
	tools: Array<string | { [key: string]: string[] }>;
};

export const ToolsLayout = (props: Props) => {
	const tools = generateTools(props.tools.sort());
	const render = () => {
		const returnValue =
			props.tools.length === 0 ? null : (
				<ToolsWrapper>
					<ToolsTitleWrapper>{language.toolsUsedHeader}:</ToolsTitleWrapper>
					{tools}
				</ToolsWrapper>
			);
		return returnValue;
	};
	const outerReturnValue = render();
	return outerReturnValue;
};

const generateTools = (tools: Array<string | { [key: string]: string[] }>): string => {
	tools = sortEntries(tools);
	const result = tools.map((tool) => {
		if (typeof tool === 'string') {
			return tool;
		} else {
			const [key, values] = Object.entries(tool)[0];
			const sortedValues = values.slice().sort(); // avoid mutating original array
			return `${key} (${sortedValues.join(', ')})`;
		}
	});
	const returnValue = result.join(', ');
	return returnValue;
};

const sortEntries = (tools: Array<string | { [key: string]: string[] }>) => {
	const returnValue = tools.slice().sort((a, b) => {
		const aKey = typeof a === 'string' ? a : Object.keys(a)[0];
		const bKey = typeof b === 'string' ? b : Object.keys(b)[0];
		return aKey.localeCompare(bKey);
	});
	return returnValue;
};
